export default __webpack_public_path__ + "static/SRUS 4335 - Especification Del Producto y Datos Técnicos-28c80a7ee727f29390dae8200324cd1d.pdf";